import React from 'react'
import { Box } from '@ui'
import { StakableOperator } from 'hooks/useOperatorData'
import { pillShimmerClass } from 'ui/styles/globals/shimmer.css'

const sizeMap = {
    xs: { width: 'x2', borderRadius: 'xs' },
    sm: { width: 'x4', borderRadius: 'xs' },
    md: { width: 'x6', borderRadius: 'sm' },
} as const

type Props = {
    nodeOperator: StakableOperator | undefined
    size?: keyof typeof sizeMap
}

export const NodeOperatorIcon = ({ nodeOperator, size = 'md' }: Props) => {
    const { width, borderRadius } = sizeMap[size]
    const image = nodeOperator?.image
    const imageStyle = image
        ? {
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
          }
        : {}
    return (
        <Box
            width={width}
            height={width}
            className={image ? undefined : pillShimmerClass}
            style={imageStyle}
            borderRadius={borderRadius}
        />
    )
}
